import { render, staticRenderFns } from "./ProcedureModelShow.vue?vue&type=template&id=b34ab9de&"
import script from "./ProcedureModelShow.vue?vue&type=script&lang=js&"
export * from "./ProcedureModelShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports